module.exports = __webpack_public_path__ + "static/media/01en.48aff12f.jpg";